import { AbstractDTO } from "./abstract";

export class UserPropertyFieldDTO extends AbstractDTO {

    key: string;
    alias: string;
    type: string;
    codesc: string;
    disableInEdit: boolean;
    onlyInEdit: boolean;
    isSupplier: number;
    mandatory: boolean;
    order: number;
    searchOnly: boolean;
    list$;

    constructor(attributes?: object) {
        super(attributes);
        attributes = attributes || {};
        this.key = attributes['field'];
        this.alias = attributes['alias'] || this.key;
        this.type = attributes['field_type'] || 'text';
        this.codesc = attributes['codesc'] || '';
        this.disableInEdit = attributes['disable_in_edit'] == '1';
        this.onlyInEdit = attributes['only_in_edit'] == '1';
        this.mandatory = attributes['mandatory'] == '1';
        this.searchOnly = attributes['search_only'] == '1';
        this.isSupplier = Number(attributes['is_supplier']) || 0;
        this.order = Number(attributes['order']) || 0;
    }

}
